<template>
    <div class="api container">
        <div v-show="stage === 0" class="grid u-justify-content-center">
            <div class="cell-24 cell-16-md">
                <h2 class="h4">Choose your city</h2>
                    <p>Which Enchant event would you like tickets for?</p>
            </div>
        </div>
        <div v-show="stage === 0" class="grid u-mt-10-sm u-justify-content-center u-t-center">
            <div class="choose-your-city u-mb-2 u-mb-5-md cell-22">
                <a v-for="s in sellers" v-bind:key="s.id" @click="selectCity(s)" class="choose-your-city__city">
                    <span class="h3 u-t-h1-md">{{s.city}}<span class="u-sr"> , DC</span></span>
                    <h4 class="h6 u-sr">Venue</h4>
                </a>
            </div>
            <div class="cell-24">
                <p>
                    Book now to secure your reservation.
                    <br>
                    Tickets are cheapest online.
                </p>
            </div>
        </div>


            <!-- <b-row class="e-select-session-row" v-for="seller in sellers" v-bind:key="seller.id" @click="selectCity(seller)">
                <b-col>{{seller.city}}</b-col>
            </b-row> -->

        <div v-show="stage === 1" class="grid u-justify-content-center">
            <div class="cell-24 cell-16-md">
                <h1 class="h4">Choose your tickets</h1>
                <p>Select the tickets you would like below.</p>
                <span>Selected: {{selectedTicketGroup.name}}</span>
            </div>
            <div class="cell-24 cell-20-sm cell-16-lg">

                <div class="ticket-slider">
                    <div class="ticket-slider-container swiper-container js-ticket-slider">
                        <div class="ticket-slider-inner swiper-wrapper">
                            <button v-for="t in ticketGroups" v-bind:key="t.id" @click="setTicketGroup(t)" class="ticket-slider__type">
                                <span>{{t.name}}</span>
                            </button>
                        </div>
                    </div>
                    <button class="ticket-slider__control ticket-slider__control__prev control" aria-label="Previous">
                        <span class="u-sr">Previous</span>
                        <svg class="control__icon" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="m7.90232679 9.57383263 8.88726751-8.88726756 2.4780727 2.4780727-8.8872834 8.88728343 8.8873991 8.8875126-2.478041 2.4780727-8.88740539-8.887538-.00386639.0038664-2.4780727-2.4780727.00388488-.0038849-.00356784-.0035679 2.47801666-2.47807269z" />
                        </svg>
                    </button>
                    <button class="ticket-slider__control ticket-slider__control__next control" aria-label="Next">
                        <span class="u-sr">Next</span>
                        <svg class="control__icon" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="m14.8222931 7.61027264 8.8872676 8.88726756-2.4780727 2.4780727-8.8872834-8.8872834-8.88751267 8.887399-2.4780727-2.478041 8.88753802-8.88740534-.00386638-.00386639 2.47807273-2.4780727.0038848.00388488.0035679-.00356784 2.4780727 2.47801665z" transform="matrix(0 1 -1 0 24.396126 -.292054)" />
                        </svg>
                    </button>
                </div>

            </div>

            <div class="cell-24 cell-16-md">
                <div class="u-mb-4">
                    <p>For one evening, immerse yourself in the world’s biggest light maze exploring a bustling Christmas
                    market, enjoy food and beverage from artisan vendors and glide around our ice skating trail.</p>
                    <p>Admission for infants aged 0-3 is FREE!</p>
                </div>
            </div>

        <!-- Tickets -->
            <div class="cell-24 cell-16-md u-mb-3">
                <TicketControl v-show="showTickets" v-for="t in sortedTicketTypes" v-bind:key="t.name" :title="t.name" :qty.sync="t.qty" :subtitle="t.currency_amount"/>
            </div>

        <!-- Info -->
            <div class="cell-24 cell-16-md">
                <p>* You will need to bring a valid ID card for these tickets.</p>
                <hr>
                <p class="u-d-none u-d-flex-sm u-justify-content-center u-align-items-center u-mb-9">
                    <span class="icon-info icon-info--small icon-info--opaque u-mr-1">i</span>
                    Prices exclude tax and service charge.
                </p>

            </div>
        </div>
        <div v-show="stage == 2" class="grid u-flex-direction-column u-align-items-center">
            <div class="cell-24 cell-16-md u-t-center u-mb-4">

                <h1 class="h3">Choose your date</h1>
                <p class="u-t-h6">What date would you like to come and visit?</p>

            </div>

        <!-- Calendar -->
            <div class="cell-24 cell-20-md cell-23-lg cell-24-xlg u-mb-6">
                <Calendar :availability="calendarData" @selected="getAvailableSessions"/>
            </div>

            <div v-show="stage === 2 && displaySelectSession" class="cell-24 cell-16-md u-t-center u-mb-6">
                <h3 class="h3 u-mb-2">{{ moment(selectedDate).format('MMMM Do')}}</h3>
                <div class="date-detail">
                    <div class="date-detail__first-block u-d-flex u-align-items-center">
                        <div style="display: inline-block; margin-right: 0.75rem; width: 1rem; height: 1rem; background-color: rgb(227,201,133);"></div>
                        <span class="u-t-pointer u-t-underlined">Stroller night</span>
                        <span class="icon-info">i</span>
                    </div>

                    <div class="date-detail__second-block date-detail__second-block--ml">
                        *from $106 <sup>.00</sup> / <svg class="icon-flutes" height="24" viewBox="0 0 22 24" width="22" xmlns="http://www.w3.org/2000/svg"><g><path d="m9.075 2.705c-.075.66.88 1.295 1.27 1.115.275-.13.31-.715.17-1.115-.015-.075-.245-.705-.72-.705-.37311528.04241617-.66973904.33286027-.72.705z"/><path d="m10.97.62c-.1451585.15895133-.2196558.36997213-.206463.58482667.0131929.21485454.112948.41517564.276463.55517333.195.07.5-.19.62-.45 0-.05.22-.46 0-.69-.2020538-.16034493-.4879462-.16034493-.69 0z"/><path d="m11.5 2.615c-.1377409.16741361-.2021341.38330756-.1786064.59882166.0235278.2155141.1329874.41242848.3036064.54617834.2.06.5-.215.6-.5 0-.045.205-.47-.03-.69-.214468-.14654245-.5012202-.12797576-.695.045z"/><path d="m21.325 21.97c-.075-.42-1.54-.66-3-.455l-1.37-5.84c.7876063-.6591545 1.3185341-1.5741199 1.5-2.585.0430135-.3168803.0430135-.6381197 0-.955-.275-2.25-2.205-7.5-2.555-8.425l-4.665 1.09c.13.96.855 6.415 1.5 8.615.0929238.3220564.2327565.6286773.415.91.6166097.8536355 1.5262763 1.4499922 2.555 1.675l1.36 5.805c-1.4.47-2.605 1.335-2.5 1.745.14.5 2.19.33 3.575 0s3.28-1.05 3.185-1.58z"/><path d="m5.94 3.71c-.35.935-2.28 6.175-2.555 8.425-.04301351.3168803-.04301351.6381197 0 .955.18348082 1.0101395.71403641 1.9244636 1.5 2.585l-1.385 5.825c-1.465-.205-2.93.035-3 .455-.095.5 1.81 1.265 3.175 1.585s3.435.5 3.575 0c.115-.41-1.085-1.275-2.5-1.745l1.375-5.795c1.02379868-.2270781 1.92805074-.8233861 2.54-1.675.18224352-.2813227.32207616-.5879436.415-.91.66-2.2 1.39-7.655 1.5-8.615z"/></g></svg>$40 <sup>.00</sup>
                    </div>
                </div>
            </div>

            <div v-show="stage === 2 && displaySelectSession" class="cell-24 cell-9-md u-t-center">
                <h3 class="h3 u-mb-2">Choose your arrival time</h3>
                <p class="u-t-h6">Now choose the time you will arrive, you can stay at the event until it closes at 10pm.</p>
            </div>

            <div v-show="stage === 2 && displaySelectSession" class="cell-24 cell-21-md" id="sessionSelectList">
                <SessionSelect :sessions="availableSessions" @selected="setSelectedSession"/>
            </div>

            <div v-show="stage === 2 && displaySelectSession" class="cell-24 cell-16-md u-t-center">
                <div class="date-detail date-detail--no-flex-sm u-mb-4 u-mb-0-sm">
                    <div class="date-detail__first-block">
                        All arrival times are $106 <sup>.00</sup>
                    </div>

                    <div class="date-detail__second-block u-ml-2">
                        <svg class="icon-flutes" height="24" viewBox="0 0 22 24" width="22" xmlns="http://www.w3.org/2000/svg"><g><path d="m9.075 2.705c-.075.66.88 1.295 1.27 1.115.275-.13.31-.715.17-1.115-.015-.075-.245-.705-.72-.705-.37311528.04241617-.66973904.33286027-.72.705z"/><path d="m10.97.62c-.1451585.15895133-.2196558.36997213-.206463.58482667.0131929.21485454.112948.41517564.276463.55517333.195.07.5-.19.62-.45 0-.05.22-.46 0-.69-.2020538-.16034493-.4879462-.16034493-.69 0z"/><path d="m11.5 2.615c-.1377409.16741361-.2021341.38330756-.1786064.59882166.0235278.2155141.1329874.41242848.3036064.54617834.2.06.5-.215.6-.5 0-.045.205-.47-.03-.69-.214468-.14654245-.5012202-.12797576-.695.045z"/><path d="m21.325 21.97c-.075-.42-1.54-.66-3-.455l-1.37-5.84c.7876063-.6591545 1.3185341-1.5741199 1.5-2.585.0430135-.3168803.0430135-.6381197 0-.955-.275-2.25-2.205-7.5-2.555-8.425l-4.665 1.09c.13.96.855 6.415 1.5 8.615.0929238.3220564.2327565.6286773.415.91.6166097.8536355 1.5262763 1.4499922 2.555 1.675l1.36 5.805c-1.4.47-2.605 1.335-2.5 1.745.14.5 2.19.33 3.575 0s3.28-1.05 3.185-1.58z"/><path d="m5.94 3.71c-.35.935-2.28 6.175-2.555 8.425-.04301351.3168803-.04301351.6381197 0 .955.18348082 1.0101395.71403641 1.9244636 1.5 2.585l-1.385 5.825c-1.465-.205-2.93.035-3 .455-.095.5 1.81 1.265 3.175 1.585s3.435.5 3.575 0c.115-.41-1.085-1.275-2.5-1.745l1.375-5.795c1.02379868-.2270781 1.92805074-.8233861 2.54-1.675.18224352-.2813227.32207616-.5879436.415-.91.66-2.2 1.39-7.655 1.5-8.615z"/></g></svg> 8:30-9:30pm - Merry hour - $90 <sup>.00</sup>
                    </div>
                </div>

                <!-- Info -->
                <hr>
                <p class="u-d-none u-d-flex-sm u-justify-content-center u-align-items-center u-mb-9">
                    <span class="icon-info icon-info--small icon-info--opaque u-mr-1">i</span>
                    Prices exclude tax and service charge.
                </p>
            </div>
         </div>


        <!--TODO CHECKING AVAILABILITY ON ADDONS -->
        <div v-show="stage === 3" class="grid u-justify-content-center">
            <div class="cell-24 cell-9-md u-mb-4 u-t-center">
                <h1 class="h3">Choose your upgrades</h1>
                <p>Save time, money and avoid the queues, there is <br> limited availability - so book now!</p>
            </div>
        </div>
        <div v-show="stage === 3" class="grid u-justify-content-center">
            <!-- Upgrades -->
            <div class="cell-24 cell-14-md cell-8-xlg u-mb-4 u-mb-1-md">
                <UpgradeControl v-show="showTickets" 
                    v-for="t in fullAddonData" v-bind:key="t.name" 
                    :title="t.name" 
                    :qty.sync="t.qty" 
                    :subtitle="t.currency_amount" 
                    :selectedSession="selectedSession" 
                    :addon="t"/>
            </div>
        </div>
        <div v-show="stage === 3" class="grid u-justify-content-center">
             <!-- Info -->
            <div class="cell-24 cell-14-md cell-8-xlg u-t-center">
                <hr>
                <p class="u-d-none u-d-flex-sm u-justify-content-center u-align-items-center">
                    <span class="icon-info icon-info--small icon-info--opaque u-mr-1">i</span>
                        Prices exclude tax and service charge.
                </p>
            </div>
        </div>
        <div v-show="stage === 4" class="grid u-justify-content-center">
          <div class="cell-24u-mb-4 u-t-center">
            <h1 class="h3">Review your order</h1>
            <p>Please check that everything looks correct<br>with your reservation.</p>
          </div>

          <!-- Table -->
          <div class="cell-24 cell-14-md cell-8-xlg">
            <table class="table table--review-order">
              <thead>
                <tr>
                  <th>
                    <span class="u-d-block u-t-h5 u-color-white">{{seller.city}}</span>
                    <span>{{getVenueName()}}</span>
                  </th>
                  <th>
                      <span class="u-d-block u-t-h5 u-color-white">{{moment(selectedDate).format('ddd, MMMM Do')}}</span>
                      <span>Arrival at {{moment(selectedSession.start_datetime).format('LT')}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th colspan="2">
                    <span class="u-d-block u-t-h6 u-color-white">Tickets:</span>
                  </th>
                </tr>
                <tr v-for="t in ticketsHasQty" :key="t.id">
                  <td>{{t.name}}</td>
                  <td>{{t.qty}} x {{getCurrencyString(t.currency_amount)}}<sup></sup></td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <th colspan="2">
                    <span class="u-d-block u-t-h6 u-color-white">Upgrades:</span>
                  </th>
                </tr>
                <tr v-for="u in upgradesHasQty" :key="u.name">
                  <td>{{u.name}}</td>
                  <td>{{u.qty}} x {{getCurrencyString(u.currency_amount)}} <sup></sup></td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td class="u-t-bold">Subtotal:</td>
                  <td>{{reviewCart.subtotal}}<sup>00</sup></td>
                </tr>
                <tr>
                  <td>Service Charge</td>
                  <td>{{reviewCart.fee}} <sup>00</sup></td>
                </tr>
                <tr>
                  <td>Tax</td>
                  <td>{{reviewCart.tax}}<sup>00</sup></td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td class="u-t-bold">Discount</td>
                  <td>{{reviewCart.discount}} <sup>00</sup></td>
                </tr>
                <tr>
                  <td class="u-t-bold"><a href="#">Got a coupon?</a></td>
                  <td><span class="u-d-block u-t-h5 u-color-white">Total: {{reviewCart.total}} <sup>00</sup></span></td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>

        <div v-show="stage === 5" class="grid u-justify-content-center">
            <div class="cell-24 u-mb-4 u-t-center">
                <h3 class="h3">You’re almost done</h3>
                <p>Please enter your payment details to complete your booking.</p>
            </div>

        </div>
      <div v-show="stage === 5" class="grid u-justify-content-center">

        <div class="cell-24 cell-14-md cell-12-xlg u-mb-4 u-mb-4-md">
          <div class="grid">
            <div class="cell-24 cell-12-sm u-d-flex u-align-items-flex-end">
              <h2 class="h5 u-mb-0">Total due: {{reviewCart.total}}</h2>
            </div>
            <div class="cell-24 cell-12-sm u-d-flex u-align-items-flex-end u-justify-content-flex-end">
              <span>
                  <!-- TODO CREATE TIMER COUNTDOWN-->
                  Time left to reserve: <span class="u-color-gold">9m 52s</span>
              </span>
            </div>
          </div>
        </div>

      </div>
      <div v-show="stage === 5" class="grid u-justify-content-center">

        <div class="cell-24 cell-14-md cell-12-xlg">
          <!-- form -->
          <form class="grid" action="">

            <div class="cell-24">
              <div class="input-group">
                <label class="input-group__label" for="email">Email Address:</label>
                <input type="text" v-model="guestEmail" class="input-group__input js-input" id="email"
                  placeholder="Your email address here…">
              </div>
            </div>

            <div class="cell-24 cell-12-md">
              <div class="input-group">
                <label class="input-group__label" for="first-name">First Name:</label>
                <input type="text" v-model="guestFirstName" class="input-group__input js-input" id="first-name" placeholder="First name…">
              </div>
            </div>
            <div class="cell-24 cell-12-md">
              <div class="input-group">
                <label class="input-group__label" for="last-name">Last Name:</label>
                <input type="text" v-model="guestLastName" class="input-group__input js-input" id="last-name" placeholder="Last name…">
              </div>
            </div>

            <div class="cell-24">
              <div class="input-group">
                <label class="input-group__label" for="address">Address:</label>
                <input type="text" class="input-group__input js-input" id="address" placeholder="Your address here (optional)…">
              </div>
            </div>
            <div class="cell-24 cell-12-md">
              <div class="select-group">
                <label class="select-group__label u-sr" for="input-select">Country</label>
                <select class="select-group__input" id="input-select">
                  <option v-for="country in countries" :key="country.name">{{country.name}}</option>
                </select>
              </div>
            </div>
            <div class="cell-24 cell-12-md">
                <div class="input-group">
                <label class="input-group__label u-sr" for="name" >Zip code:</label>
                <input type="text" class="input-group__input js-input" placeholder="Your zip code here…" id="name">
              </div>
            </div>
            <div class="cell-24">
              <div class="input-group">
                <label class="input-group__label" for="card-number">Card details:</label>
                <Stripe @payment="completeCheckout"/>
                <!-- <input type="number" class="input-group__input js-input" id="card-number"
                  placeholder="1234   5678   1234   5678"> -->
              </div>
            </div>

            
            <!-- <div class="cell-24 cell-12-md">
              <div class="input-group">
                <label class="input-group__label u-sr" for="security">CVC:</label>
                <input type="number" class="input-group__input js-input" id="security" placeholder="CVC">
              </div>
            </div>
            <div class="cell-24 cell-12-md">
              <div class="input-group">
                <label class="input-group__label u-sr" for="expiry-date">Expiry date:</label>
                <input type="number" class="input-group__input js-input" id="expiry-date" placeholder="MM/YY">
              </div>
            </div> -->

            <div class="cell-24">
              <div class="checkbox-group">
                <input type="checkbox" class="checkbox-group__input" id="signup" value="signup">
                <label class="checkbox-group__label" for="signup">Yes! sign me up for future events and deals</label>
              </div>
            </div>

            <div class="cell-24">
                <div class="checkbox-group">
                  <input type="checkbox" class="checkbox-group__input" id="terms" value="terms">
                  <label class="checkbox-group__label" for="terms">I’ve read and accept the Ticketing <a>terms and conditions</a></label>
                </div>
              </div>

            </form>
        </div>

      </div>

        
        


        <!-- <div v-show="stage == 5" class="b-stage4-ticket-flow">
            <b-row h-align="between">
                <b-col class="text-to-the-left">Seattle</b-col>
                <b-col class="text-to-the-right">{{selectedDate}}</b-col>
            </b-row>
            <b-row h-align="between">
                <b-col class="text-to-the-left">T - Mobile</b-col>
                <b-col class="text-to-the-right">Arrival time {{moment(selectedSession.start_datetime).format('LT')}} </b-col>
            </b-row>
            <b-row v-for="ticket in cart.ticket._data" :key="ticket.id">
                <b-col class="text-to-the-left">{{getTicketTitleFromId(ticket.ticket_type_id)}}</b-col>
                <b-col class="text-to-the-right">{{getCurrencyString(ticket.adjusted_value)}}</b-col> 
            </b-row>
            <b-row h-align="between">
                <b-col class="text-to-the-left">Sub-total</b-col>
                <b-col class="text-to-the-right">{{getCurrencyString(cart.cart_fees._data[0].grand_totals.total_before_cartmod_price)}}</b-col>
            </b-row>
            <b-row h-align="between"> 
                <b-col class="text-to-the-left">Service Charge</b-col>
                <b-col class="text-to-the-right">{{getCurrencyString(cart.cart_fees._data[0].grand_totals.total_fee_fixed_outside)}}</b-col>
            </b-row>
            <b-row h-align="between">
                <b-col class="text-to-the-left">Tax</b-col>
                <b-col class="text-to-the-right">{{getCurrencyString(cart.cart_fees._data[0].grand_totals.total_fee_percent_outside)}}</b-col>
            </b-row>
            <b-row h-align="between">
                <b-col class="text-to-the-left">Coupon: {{currentCode}}</b-col>
                <b-col class="text-to-the-right">Total: {{getCurrencyString(cart.cart_fees._data[0].grand_totals.total_after_fees_price)}}</b-col>
            </b-row>
            <b-row>
                <b-input-group>
                    <b-form-input cols="12"
                      id="guest-first-name"
                      v-model="guestFirstName"
                      label="Enter your first name"
                      required >
                    </b-form-input>
                    <b-form-input
                      id="guest-last-name"
                      v-model="guestLastName"
                      label="Enter your last name"
                      required >
                    </b-form-input>
                    <b-form-input
                      id="guest-email"
                      v-model="guestEmail"
                      label="Enter your email"
                      required >
                    </b-form-input>
                </b-input-group>
            </b-row>     
            <div class="form-row flex-column">
                <Stripe @payment="completeCheckout"/> 
            </div>
            <b-row>
                <b-col>
                    <b-button @click="backToSelectSession">Edit Cart</b-button>
                </b-col>
            </b-row>
        </div> -->
        <div v-show="stage === 6" class="b-stage5-ticket-flow">
            <div>
                ORDER CONFIRMED
            </div>
        </div>
    </div>
</template>

<script>
import http from '../util/http';
import Vue from 'vue';
import TicketControl from './TicketControl';
import UpgradeControl from './UpgradeControl';
import Stripe from './Stripe';
import Calendar from './Calendar';
import SessionSelect from './SessionSelect';
import Framework from '../assets/js/framework/index';
import Swiper from 'swiper';
import countryData from '../assets/js/countries';
 
export default {
    name: 'CheckoutMainFlow',
    components: {
        TicketControl,
        Stripe,
        Calendar,
        SessionSelect,
        UpgradeControl
    },
    created() {
    },
    mounted() {
        const framework = new Framework();
        if(this.$route.query.city) {
            let city = this.sellers.find((s) => s.key === this.$route.query.city);
            this.selectCity(city);
        }
    },
    computed: {
        countries() {
            return countryData.data;
        },
        ticketsHasQty() {
            return this.ticketTypes.filter(t => t.qty > 0);
        },
        upgradesHasQty() {
            return this.fullAddonData.filter(u => u.qty > 0);
        },
        sellers() {
            return this.$store.state.checkout.sellers;
        },
        eventTemplates() {
            return this.$store.state.checkout.eventTemplates;
        },
        addonEvents() {
            return this.$store.state.checkout.addonEvents;
        },
        eventSessions() {
            return this.$store.state.checkout.eventSessions;
        },
        ticketTypes() {
            return this.$store.state.checkout.ticketTypes;
        },
        ticketGroups() {
            return this.$store.state.checkout.ticketGroups;
        },
        addonGroups() {
            return this.$store.state.checkout.addonGroups;
        },
        addonEvents() {
            return this.$store.state.checkout.addonEvents;
        },
        availableCalendar() {
            return this.$store.state.checkout.availableCalendar;
        },
        availableSessions: {
            get() {
                return this.$store.state.checkout.availableSessions;
            },
            set(sessions) {
                this.$store.dispatch('checkout/setAvailableSessions', sessions);
            }      
        },
        cart() {
            return this.$store.state.checkout.cart;
        },
        guestIdentity() {
            return this.$store.state.checkout.guestIdentity; 
        },
        triggerNextStage() {
            return this.$store.state.checkout.triggerNextStage;
        },
        stage: {
            get() {
                return this.$store.state.checkout.stage;
            },
            set(stg) {
                this.$store.dispatch('checkout/setStage', stg);
            }
        },
        fullAvailabilityPrice() {
            return this.$store.state.checkout.fullAvailabilityPrice;
        },
        venues() {
            return this.$store.state.checkout.venues;
        },
        fullAddonData: {
            get() {
                return this.$store.state.checkout.fullAddonData;
            },
            set(data) {
                this.$store.dispatch('checkout/setFullAddonData', data);
            }
        }
    },
    data: function() {
        return {
            eventTemplateId: "b42a8254-5487-355e-db6f-831ec41809bd",
            ticketGroupId: "c372e795-a64e-19b8-65de-74e5b56f2455",
            selectedTicketGroup: {},
            selectedAddonGroup: {},
            sellerId: "",
            seller: {},
            spinning: false,
            response: {},
            ready: false,
            showTickets: false,
            sortedTicketTypes: [],
            addonTicketTypes:[{}],
            sortedTicketGroups: [{}],
            sortedAddonTypes: [{}],
            selectedDate: "",
            selectedSession: {},
            displaySelectSession: false,
            addonSession: {},
            cartCreated: false,
            guestFirstName: "",
            guestLastName: "",
            guestEmail: "",
            currentCode: "No coupon",
            addonGroupId: "",
            calendarData: [{date: this.moment(), availability: ''}],
            reviewCart: {
                subtotal: "",
                tax: "",
                fee:"",
                discount:"",
                total:""
            },
            slider: {}
        }
    },
    methods: {
        createCartReviewObject() {

            if(this.cart.cart_fees._data[0].grand_totals) {
                let subtotal = this.cart.cart_fees._data[0].grand_totals.total_before_cartmod_price;
                let tax = this.cart.cart_fees._data[0].grand_totals.total_fee_percent_outside;
                let fee = this.cart.cart_fees._data[0].grand_totals.total_fee_fixed_outside;
                let discount = this.cart.cart_fees._data[0].grand_totals.total_cartmod_amount;
                let total = this.cart.cart_fees._data[0].grand_totals.total_after_fees_price;

                this.reviewCart = {
                    subtotal: subtotal,
                    tax: tax,
                    fee: fee,
                    discount: discount,
                    total: total
                };
            }
            
        },
        initSwiper() {
            this.slider = new Swiper('.js-ticket-slider', {
                slidesPerView: 'auto',
                spaceBetween: 0,
                centeredSlides: true,
                direction: 'horizontal',
                loop: false,
                slideClass: 'ticket-slider__type',
                navigation: {
                nextEl: '.ticket-slider__control__next',
                prevEl: '.ticket-slider__control__prev'
                }
            })
        },
        // put in a mixin?
        getCurrencyString(value) {
            return '$' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },
        getVenueName() {
            if(this.venues.length > 0) {
                return this.venues[0].name;
            } else {
                return "";
            }
        },
        moveToStageOne() {
            http.get("/api/events/available", {
                params: {
                    "seller_id": this.sellerId
                }
            }).then((resp) => {
                this.$store.dispatch('checkout/updateEventTemplates', resp.data).then(() => {
                    this.ready = true;
                    this.stage = 1;
                    this.createAddonObjects();
                });
            }).catch((err) => {
                console.log(JSON.stringify(err));
            })
        },
        selectCity(item) {
            this.sellerId = item.id;
            this.seller = item;
            this.moveToStageOne();
        },
        setTicketGroup(item) {
            this.showTickets = true;
            this.ticketGroupId = item.id;
            this.selectedTicketGroup = item;
        },
        setAddonGroup(item) {
            this.showTickets = true;
            this.addonGroupId = item.id;
            this.selectedAddonGroup = item;
        },
        createServerCart(event) {
            this.spinning = true;
            http.post("/api/my/cart/").then((resp) => {
                this.$store.dispatch('checkout/updateCart', resp.data).then(() => {
                    this.cartCreated = true;
                    this.spinning = false;
                });
            }).catch((err) => {
                console.log(JSON.stringify(err));
            })
        },
        backToAddTickets() {
            this.stage = 1;
        },
        getAvailableCalendar(id) {
            this.createServerCart();
            this.postSelectedTicketsForAvailability().then(()=> {
                this.convertPriceScheduleToCalendarData();
            });
            http.get("/api/events/" + this.selectedTicketGroup.event_template_id + "/calendar").then((resp) => {
                this.$store.dispatch('checkout/updateAvailableCalendar', resp.data).then(() => {
                    this.spinning = false;
                    this.stage = 2;
                });
            }).catch((err) => {
                console.log(JSON.stringify(err));
            })
        },

        convertPriceScheduleToCalendarData() {
            
            let j = 0;
            let days = [];
            let tmpDay = { sessions: [], date: "", priceHigh: "", priceLow: ""};
            let allSessions = this.fullAvailabilityPrice.event_session._data;
            let price_schedules = this.fullAvailabilityPrice.price_schedule._data;
            
            tmpDay.date = this.moment.tz(allSessions[0].start_datetime, this.seller.timezone).startOf('day');
            tmpDay.sessions.push(allSessions[0]);
            let dayPriceHigh = 0;
            let dayPriceLow = "";

            for (let i = 0; i < price_schedules.length; i++) {
                while(j < allSessions.length) {
                    if (price_schedules[i].currency_amount > dayPriceHigh) {
                        dayPriceHigh = price_schedules[i].currency_amount;
                    } 
                    if (dayPriceLow === "" || price_schedules[i].currency_amount < dayPriceLow )
                    {
                        dayPriceLow = price_schedules[i].currency_amount;
                    } 
                    if(this.moment(allSessions[j].start_datetime).isAfter(this.moment(price_schedules[i].to))) {
                        break;
                    }
                    if (this.moment.tz(allSessions[j].start_datetime, this.seller.timezone).isSame(tmpDay.date, 'day')) {
                       if (this.moment(allSessions[j].start_datetime).isSameOrAfter( this.moment(price_schedules[i].from)) 
                       &&  this.moment(allSessions[j].end_datetime).isSameOrBefore(this.moment(price_schedules[i].to))) {
                           tmpDay.sessions.push(allSessions[j]);
                            j++;
                       } else {
                           break;
                       }
                    } else {
                        tmpDay.priceHigh = dayPriceHigh;
                        tmpDay.priceLow = dayPriceLow;
                        days.push(tmpDay);
                        let nextDay = tmpDay.date.clone().add(1, 'days');
                        tmpDay = { sessions: [], date: "", priceHigh: "", priceLow: ""};
                        dayPriceHigh = 0;
                        dayPriceLow = "";
                        
                        tmpDay.date = nextDay;                  
                    }
                }
            }

            for(let x = 0; x < days.length; x++) {
                let k = days[x].date.format("Y-MM-DD");
                if(this.availableCalendar[k]) {
                    days[x].availability = this.availableCalendar[k];
                }

            }
            
            this.calendarData = days;
        },
        // use event template id
        getAvailableSessions(selectedDate) {
            this.selectedDate = selectedDate;
            http.get("/api/events/" + this.selectedTicketGroup.event_template_id + "/sessions?_ondate=" + this.selectedDate).then((resp) => {
                this.$store.dispatch('checkout/updateAvailableSessions', resp.data).then(() => {
                    this.displaySelectSession = true;
                    Vue.nextTick(function() {
                        document.getElementById('sessionSelectList').scrollIntoView({ behavior: 'smooth' });
                    });
                    this.spinning = false;
                    
                });
            }).catch((err) => {
                console.log(JSON.stringify(err));
            })
        },
        setSelectedSession(item) {
            this.selectedSession = item;
        },
        // stage 4 is addons .  
        moveToStageFour(item) {
            this.showTickets = false;
            this.selectedSession = item;
            this.stage = 4;
        },
        // stage 5 is cart summary.  
        moveToStageFive() {
            this.resolveAddonSession.then(() =>{
                this.addSelectedSessionTicketsToCart().then(() => {
                    this.stage = 5
                });
            })    
        },
        backToSelectDate() {
            this.stage = 2;
        },

        backToSelectSessionn() {
            this.spinning = true;
            http.delete("/api/my/cart/" + this.cart.id).then((resp) => {
                this.$store.dispatch('checkout/resetCart', resp.data).then(() => {
                    this.cartCreated = false;
                    this.spinning = false;
                });
                http.post("/api/my/cart/").then((resp) => {
                    this.$store.dispatch('checkout/updateCart', resp.data).then(() => {
                        this.cartCreated = true;
                        this.spinning = false;
                    });
                }).catch((err) => {
                    console.log(JSON.stringify(err));
                })
            }).catch((err) => {
                console.log(JSON.stringify(err));
            })
            
            this.stage = 3;
        },
        upsertGuestUser() {
            return new Promise((resolve, reject) => {
                http.post("/api/user/", {
                    'first_name': this.guestFirstName,
                    'last_name': this.guestLastName,
                    'email': this.guestEmail
                }).then((resp) => {
                    this.$store.dispatch('checkout/updateGuestIdentity', resp.data).then(() => {
                        console.log("A USER HAS BEEN UPSERTED");
                        resolve();
                    });
                }).catch((err) => {
                    console.log(JSON.stringify(err));
                    reject();
                })
            });
        },
        postSelectedTicketsForAvailability() {
            let self = this;
            let tmpCart = [];
            for(let i = 0; i < self.sortedTicketTypes.length; i++) {
                if(self.sortedTicketTypes[i].qty > 0) {
                    tmpCart.push({
                        'ticket_type_id': self.sortedTicketTypes[i].id,
                        "quantity": self.sortedTicketTypes[i].qty
                        // 'admit_name': this.guestFirstName + ' ' + this.guestLastName,
                        // 'admit_email': this.guestEmail
                    });
                }   
            }

            let body = {
                'ticket_types_required': tmpCart
            }
            return new Promise((resolve, reject) => {
                http.post("/api/events/" + this.selectedTicketGroup.event_template_id + "/sessions", body).then((resp) => {
                    this.$store.dispatch('checkout/setFullAvailabilityPrice', resp.data).then(()=> {
                        resolve();
                    })
                }).catch((err) => {
                    reject(err);
                });
            })
            
        },
        resolveAddonSession() {
            // pseudo logic
            // have selected date from other tickets
            // 
            return new Promise((resolve, reject) => {
                http.get("/api/events/" + this.selectedAddonGroup.event_template_id+ "/sessions?_ondate=" + this.selectedDate).then((resp) => {
                    this.addonSession = resp.data.event_session._data[0];
                    resolve();
                }).catch((err) => {
                    console.log(JSON.stringify(err));
                    reject();
                })
            })
            
        },
        addSelectedSessionTicketsToCart() {
            let self = this;
            return new Promise((resolve, reject) => {
                let tmpCart = [];
                for(let i = 0; i < self.sortedTicketTypes.length; i++) {
                    for(let j = 0; j < self.sortedTicketTypes[i].qty; j++) {
                        let gId = self.sortedTicketTypes[i].ticket_group_id;
                        let group = self.ticketGroups.find(o => o.id === gId);
                        let templateId = group.event_template_id;
                        let template = self.eventTemplates.find(o => o.id === templateId);
                        
                        if(template.category === "membership") {
                            tmpCart.push({
                                'ticket_type_id': self.sortedTicketTypes[i].id//,
                                // 'admit_name': this.guestFirstName + ' ' + this.guestLastName,
                                // 'admit_email': this.guestEmail
                            });
                        } else {
                            tmpCart.push({
                                'event_session_id': self.selectedSession.id,
                                'ticket_type_id': self.sortedTicketTypes[i].id//,
                                // 'admit_name': this.guestFirstName + ' ' + this.guestLastName,
                                // 'admit_email': this.guestEmail
                            });
                        }
                    }
                }

                for(let x = 0; x < self.fullAddonData.length; x++) {
                    let s = self.getCorrectAddonSession(self.fullAddonData[x]);
                
                    for(let y = 0; y < self.fullAddonData[x].qty; y++) {
                            tmpCart.push({
                                'event_session_id': s.id,
                                'ticket_type_id': self.fullAddonData[x].ticket_type_id//,
                                // 'admit_name': this.guestFirstName + ' ' + this.guestLastName,
                                // 'admit_email': this.guestEmail
                            });
                        
                    }
                }   

                http.post("/api/my/cart/" + self.cart.id + "/reserve", {
                    "tickets": tmpCart
                }).then((resp) => {
                    self.$store.dispatch('checkout/updateCart', resp.data).then(() => {
                        console.log("update cart");
                        resolve();
                    });
                }).catch((err) => {
                    console.log(JSON.stringify(err));
                    reject();
                })
            })
        },
        getCorrectAddonSession(addonObj) {
            let sessions = addonObj.availability.event_session._data;
            let ticketSessionStart = this.moment(this.selectedSession.start_datetime);
            let ticketSessionEnd = this.moment(this.selectedSession.end_datetime);

            let i = 0;

            //TODO unit test this logic
            while(i < sessions.length) {
                
                let addonStart = this.moment(sessions[i].start_datetime);
                let addonEnd = this.moment(sessions[i].end_datetime);


                if(ticketSessionStart.isSameOrAfter(addonStart) && ticketSessionEnd.isSameOrBefore(addonEnd)) {
                    return sessions[i]
                }
                i++;
            }

            return null;
        },
        completeCheckout(e) {
            let self = this;
            //TODO handle $0 transactions 
            this.upsertGuestUser().then(() => {
                http.post("/api/my/cart/" + self.cart.cart._data[0].id + "/checkout", {
                    "gateway_id": "stripe",
                    "gateway_data": {
                        "source": e.id
                    },
                    "guest_identity_id": self.guestIdentity.identity._data[0].id,
                    "send_email": true
                }).then((resp) => {
                    self.$store.dispatch('checkout/updateOrder', resp.data).then(() => {
                        console.log("ORDER CONFIRMED");
                        self.stage = 6;
                    });
                }).catch((err) => {
                    console.log(JSON.stringify(err));
                })
            });
        },
        membershipCheckout() {

        },
        getTicketTitleFromId(id) {
            if(id !== "") {
                let t = this.ticketTypes.find(e => e.id === id);
                if (t !== undefined) {
                    return t.name;
                } else {
                    return "";
                }
            }
        },
        toggleSelected(item) {
            item.selected
        },
        createAddonObjects() {
            let tmp = []
            for(let i = 0; i < this.addonEvents.length; i++) {
                let a = {}

                let addonEventTemplate = this.addonEvents[i];
                let addonEventId = addonEventTemplate.id;
                let addonGroup = this.addonGroups.find(group => group.event_template_id === addonEventId);

                let addonGroupId = addonGroup.id;
                let addonTicketType = this.ticketTypes.find(type => type.ticket_group_id === addonGroupId);

                a.name = addonEventTemplate.name;
                a.event_type = addonEventTemplate.event_type;
                a.venue_id = addonEventTemplate.venue_id;
                a.event_template_id = addonEventId;

                a.description = addonGroup.description;
                a.currency_amount = addonTicketType.currency_amount;
                a.ticket_type_id = addonTicketType.id;
                
                a.qty = 0;

                tmp.push(a);
            }

            this.fullAddonData = tmp;
        },
        getAddonAvailability() {
            let promises = [];

            for(let i = 0; i < this.fullAddonData.length; i++) {
                let tmp = new Promise((resolve, reject) => {
                    http.get("/api/events/" + this.fullAddonData[i].event_template_id + "/sessions").then((resp) => {
                        let f = this.fullAddonData;
                        f[i].availability = resp.data;
                        this.$store.dispatch('checkout/setFullAddonData', f).then(() => {
                            resolve();
                        });
                    }).catch((err) => {
                        console.log(JSON.stringify(err));
                        reject();
                    })
                });
                promises.push(tmp);
            }
            
            return Promise.all(promises);
        }
    },

    watch: {
        ticketGroupId: function(n, old) {
            this.sortedTicketTypes = this.ticketTypes.filter((o) => {
                return o.ticket_group_id === n;
            })
        },
        addonGroupId: function(n, old) {
            this.sortedAddonTypes = this.ticketTypes.filter((o) => {
                return o.ticket_group_id === n;
            })
        },
        ticketTypes: function (newT, oldT) {
            this.sortedTicketTypes = newT.filter((o) => {
                return o.ticket_group_id === this.ticketGroupId;
            })
        },
        ticketGroups: function() {
            this.initSwiper();
        },
        triggerNextStage: function(newTrigger, oldTrigger) {
            if(newTrigger) {
                switch(this.stage) {
                    case 0:
                        //do something
                        break;
                    case 1: 
                        this.getAvailableCalendar();
                        this.$store.dispatch("checkout/resetStageTrigger");
                        break;
                    case 2:
                        //do something
                        this.stage = 3;
                        this.getAddonAvailability().then(() => {
                            this.stage = 3;
                        })
                        this.$store.dispatch("checkout/resetStageTrigger");
                        break;
                    case 3:
                        //do something
                        this.addSelectedSessionTicketsToCart().then(() =>{
                            this.createCartReviewObject();
                            this.stage = 4;
                        });
                        this.$store.dispatch("checkout/resetStageTrigger");
                        break;
                    case 4: 
                        //do something
                        this.stage = 5;
                        break;
                    case 5:
                        //do something
                        break;
                    default:
                        break;
                }
            }
        }
    }

}
</script>

<style>
</style>
